<template>
  <el-main>
    <!-- 類型選擇 -->
    <div>
      <el-radio-group
        v-if="!data1.sort.status"
        v-model="nowCategoryId"
        size="medium"
      >
        <el-radio-button
          v-for="item in categoryList"
          :key="item.name"
          :label="item.id"
          >{{ item.name }}</el-radio-button
        >
      </el-radio-group>
    </div>
    <!-- 間隔 -->
    <br />
    <!-- data1 sort btn -->
    <el-button
      v-if="!data1.sort.status && data1.data.length > 0"
      @click="data1OpenSortFunction()"
      >排序</el-button
    >
    <el-button v-if="data1.sort.status" @click="data1SubmitSort()"
      >確定</el-button
    >
    <el-button v-if="data1.sort.status" @click="data1CloseSortFunction()"
      >取消</el-button
    >
    <!-- data1 add btn -->
    <el-button
      type="primary"
      v-if="!data1.sort.status"
      @click="data1.addForm1.dialogVisible = true"
      >+ 連結</el-button
    >
    <!-- 間隔 -->
    <br /><br />
    <!-- data1 table -->
    <el-table :data="data1.data" style="width: 100%">
      <el-table-column label="編號">
        <template slot-scope="scope">
          <div v-if="data1.sort.status">
            <el-button
              v-if="scope.$index !== 0"
              icon="el-icon-top"
              @click="data1SortUpdateIndex(scope.$index, scope.$index - 1)"
            ></el-button>
            <el-button
              v-if="scope.$index !== data1.data.length - 1"
              icon="el-icon-bottom"
              @click="data1SortUpdateIndex(scope.$index, scope.$index + 1)"
            ></el-button>
          </div>
          <div v-if="!data1.sort.status">
            {{ scope.$index + 1 }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="連結名稱">
        <template slot-scope="scope">
          <el-link :href="scope.row.url" target="_blank">{{
            scope.row.name
          }}</el-link>
        </template>
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <el-button @click="data1UpdateForm1DialogOpen(scope.$index)"
            >編輯</el-button
          >
          <el-button @click="data1Delete(scope.$index)">刪除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- data1 add dialog -->
    <el-dialog
      title="新增"
      :visible.sync="data1.addForm1.dialogVisible"
      width="30%"
      @closed="data1AddForm1DialogClosed()"
      :close-on-click-modal="false"
    >
      <el-form
        :model="data1.addForm1.data"
        status-icon
        :rules="data1.addForm1.rules"
        ref="data1AddForm1"
        label-width="100px"
        class="demo-ruleForm"
        v-loading.lock="data1.addForm1.loading"
      >
        <el-form-item label="連結名稱" prop="name">
          <el-input
            type="text"
            v-model.trim="data1.addForm1.data.name"
            autocomplete="off"
            maxlength="60"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="連結" prop="url">
          <el-input
            type="text"
            v-model.trim="data1.addForm1.data.url"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="">
          <el-alert
            v-show="data1.addForm1.errorMessage.length > 0"
            type="error"
            :closable="false"
            >{{ data1.addForm1.errorMessage }}
          </el-alert>
        </el-form-item>
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button @click="data1.addForm1.dialogVisible = false"
              >取消</el-button
            >
            <el-button type="primary" @click="data1AddForm1Submit()"
              >送出</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- data1 update dialog -->
    <el-dialog
      title="編輯"
      :visible.sync="data1.updateForm1.dialogVisible"
      width="30%"
      @closed="data1UpdateForm1DialogClosed()"
      :close-on-click-modal="false"
    >
      <el-form
        :model="data1.updateForm1.data"
        status-icon
        :rules="data1.updateForm1.rules"
        ref="data1UpdateForm1"
        label-width="100px"
        class="demo-ruleForm"
        v-loading.lock="data1.updateForm1.loading"
      >
        <el-form-item label="連結名稱" prop="name">
          <el-input
            type="text"
            v-model.trim="data1.updateForm1.data.name"
            autocomplete="off"
            maxlength="60"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="連結" prop="url">
          <el-input
            type="textarea"
            :rows="5"
            v-model.trim="data1.updateForm1.data.url"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="">
          <el-alert
            v-show="data1.updateForm1.errorMessage.length > 0"
            type="error"
            :closable="false"
            >{{ data1.updateForm1.errorMessage }}
          </el-alert>
        </el-form-item>
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button @click="data1.updateForm1.dialogVisible = false"
              >取消</el-button
            >
            <el-button type="primary" @click="data1UpdateForm1Submit()"
              >送出</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-main>
</template>

<script>
import {
  B_LawCompliance_Add,
  B_LawCompliance_GetList,
  B_LawCompliance_Update,
  B_LawCompliance_Delete,
  B_LawCompliance_Sort,
} from '@/assets/js/api';

export default {
  data() {
    return {
      nowCategoryId: 1,
      categoryList: [
        { id: 1, name: '洗錢防制專區' },
        { id: 2, name: '法令相關' },
        { id: 3, name: '其它連結' },
      ],
      data1: {
        data: [],
        addForm1: {
          dialogVisible: false,
          loading: false,
          formRef: 'data1AddForm1',
          errorMessage: '',
          data: {
            name: '',
            url: '',
          },
          rules: {
            name: [
              { required: true, message: '請輸入連結名稱' },
              { min: 1, max: 60, message: '連結名稱必須在60個字元內' },
            ],
            url: [{ required: true, message: '請輸入連結' }],
          },
        },
        updateForm1: {
          updateId: 0,
          dialogVisible: false,
          loading: false,
          formRef: 'data1UpdateForm1',
          errorMessage: '',
          data: {
            name: '',
            url: '',
          },
          rules: {
            name: [
              { required: true, message: '請輸入連結名稱' },
              { min: 1, max: 60, message: '連結名稱必須在60個字元內' },
            ],
            url: [{ required: true, message: '請輸入連結' }],
          },
        },
        sort: {
          status: false,
          originalDataTemp: [], // 開始更新時先保留原始資料
        },
      },
    };
  },
  components: {},
  mounted() {
    this.data1GetList();
  },
  methods: {
    // data1 get list
    data1GetList() {
      B_LawCompliance_GetList(this.nowCategoryId)
        .then((res) => {
          this.data1.data = res.data.data;
        })
        .catch((err) => {
          this.data1.addForm1.errorMessage = err.response.data.message;
        });
    },
    // data1 add
    data1AddForm1DialogClosed() {
      this.data1.addForm1.loading = false;
      this.$refs[this.data1.addForm1.formRef].resetFields();
      this.data1.addForm1.errorMessage = '';
    },
    data1AddForm1Submit() {
      this.$refs[this.data1.addForm1.formRef].validate((valid) => {
        this.data1.addForm1.data.categoryId = this.nowCategoryId;
        if (valid) {
          this.data1.addForm1.errorMessage = '';
          this.data1.addForm1.loading = true;
          B_LawCompliance_Add(this.data1.addForm1.data)
            .then(() => {
              this.$notify({
                title: '成功',
                message: '新增成功',
                type: 'success',
              });
              this.data1.addForm1.dialogVisible = false;
              this.data1GetList();
            })
            .catch((err) => {
              this.data1.addForm1.loading = false;
              this.data1.addForm1.errorMessage = err.response.data.message;
            });
        }
      });
    },
    // data1 update
    data1UpdateForm1DialogOpen(index) {
      this.data1.updateForm1.data = { ...this.data1.data[index] };
      this.data1.updateForm1.updateId = this.data1.data[index].id;
      this.data1.updateForm1.dialogVisible = true;
    },
    data1UpdateForm1DialogClosed() {
      this.data1.updateForm1.loading = false;
      this.$refs[this.data1.updateForm1.formRef].resetFields();
      this.data1.updateForm1.updateId = 0;
      this.data1.updateForm1.errorMessage = '';
    },
    data1UpdateForm1Submit() {
      this.$refs[this.data1.updateForm1.formRef].validate((valid) => {
        if (valid) {
          this.data1.updateForm1.errorMessage = '';
          this.data1.updateForm1.loading = true;
          B_LawCompliance_Update(
            this.data1.updateForm1.updateId,
            this.data1.updateForm1.data,
          )
            .then(() => {
              this.$notify({
                title: '成功',
                message: '修改成功',
                type: 'success',
              });
              this.data1.updateForm1.dialogVisible = false;
              this.data1GetList();
            })
            .catch((err) => {
              this.data1.updateForm1.loading = false;
              this.data1.updateForm1.errorMessage = err.response.data.message;
            });
        }
      });
    },
    // data1 delete
    data1Delete(index) {
      this.$confirm('確定刪除?', '確認', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          B_LawCompliance_Delete(this.data1.data[index].id)
            .then(() => {
              this.$notify({
                title: '成功',
                message: '刪除成功',
                type: 'success',
              });
              this.data1GetList();
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: 'warning',
              });
            });
        })
        .catch(() => {});
    },
    // data1 sort
    data1OpenSortFunction() {
      this.data1.sort.status = true;
      this.data1.sort.originalDataTemp = [...this.data1.data]; // 暫存原本資料
    },
    data1CloseSortFunction() {
      this.data1.sort.status = false;
      this.data1.data = [];
      this.data1.data = [...this.data1.sort.originalDataTemp]; // 回復原本資料
    },
    data1SortUpdateIndex(originalIndex, newIndex) {
      [this.data1.data[originalIndex], this.data1.data[newIndex]] = [
        this.data1.data[newIndex],
        this.data1.data[originalIndex],
      ];
      const temp = this.data1.data;
      this.data1.data = [];
      this.data1.data = temp;
    },
    data1SubmitSort() {
      const sortList = [];

      this.data1.data.forEach((item, index) => {
        sortList.push({
          id: item.id,
          sortNumber: index,
        });
      });
      B_LawCompliance_Sort(sortList)
        .then(() => {
          this.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success',
          });
          this.data1.sort.status = false;
          this.data1GetList();
        })
        .catch((err) => {
          this.$message({
            message: err.response.data.message,
            type: 'warning',
          });
        });
    },
  },
  watch: {
    nowCategoryId() {
      this.data1GetList();
    },
  },
};
</script>
